import React, { Fragment } from 'react';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    templateAlertButton: {
        width: '100%',
        borderRadius: theme.shape.borderRadius,
        textAlign: 'left',
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.warning.main}`,
            outlineOffset: 2,
        },
    },
    templateAlertAnimating: {
        animation: '$templateAlertPulse 700ms ease-in-out infinite',
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
        },
    },
    templateAlert: {
        width: '100%',
        cursor: 'pointer',
    },
    '@keyframes templateAlertPulse': {
        '0%, 100%': {
            transform: 'translateX(0)',
        },
        '10%, 30%': {
            transform: 'translateX(-3px)',
        },
        '20%, 40%': {
            transform: 'translateX(3px)',
        },
        '50%': {
            transform: 'translateX(0)',
        },
    },
}));

export const AlertsConversations = ({
    isBlocked,
    isChannelEnabled,
    hasActiveCustomerResponse,
    isTemplateAlertAnimating,
    onSendTemplate,
}: {
    isBlocked: boolean;
    isChannelEnabled: boolean;
    hasActiveCustomerResponse: boolean;
    isTemplateAlertAnimating: boolean;
    onSendTemplate: () => void;
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const Container = ({ children }: { children: React.ReactNode }) => (
        <Box
            style={{
                padding: '10px 5px',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Box style={{ maxWidth: '80%' }}>{children}</Box>
        </Box>
    );

    return (
        <Fragment>
            {isBlocked && (
                <Container>
                    <Alert severity="error">
                        {t('Errors.ConversationBlocked')}
                    </Alert>
                </Container>
            )}
            {!isChannelEnabled && (
                <Container>
                    <Alert severity="warning">
                        {t('Errors.NoActiveConversationChannel')}
                    </Alert>
                </Container>
            )}
            {isChannelEnabled && !hasActiveCustomerResponse && !isBlocked && (
                <Container>
                    <ButtonBase
                        className={`${classes.templateAlertButton} ${
                            isTemplateAlertAnimating
                                ? classes.templateAlertAnimating
                                : ''
                        }`}
                        onClick={onSendTemplate}
                        aria-label={t('Errors.24Hours')}
                    >
                        <Alert
                            severity="warning"
                            className={classes.templateAlert}
                        >
                            {t('Errors.24Hours')}
                        </Alert>
                    </ButtonBase>
                </Container>
            )}
        </Fragment>
    );
};
